export const OVERLAP_DATE_MESSAGE = 'لايمكن تداخل تواريخ المساقات'

export const OUT_OF_BOUND_DATE_MESSAGE = 'لايمكن تجاوز فترة المساق'
